var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1402_4445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3977 8.78104C1.31677 8.32557 1.68635 7.92969 2.14896 7.92969H13.9913C14.4539 7.92969 14.8235 8.32557 14.7426 8.78104C13.4488 16.063 2.69146 16.063 1.3977 8.78104Z",
    fill: "#5A6068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0129 6.57777C4.16321 5.97655 4.54482 4.81461 3.56199 4.32319C2.66016 3.87228 2.66016 3.12075 2.66016 2.51953",
    stroke: "#5A6068",
    strokeWidth: 0.956804,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26681 6.57777C6.41711 5.97655 6.79873 4.81461 5.81589 4.32319C4.91406 3.87228 4.91406 3.12075 4.91406 2.51953",
    stroke: "#5A6068",
    strokeWidth: 0.956804,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62156 7.03125L14.25 7.03125C13.9367 5.4876 12.5719 4.32575 10.9358 4.32575C9.29966 4.32575 7.93491 5.4876 7.62156 7.03125Z",
    fill: "#5A6068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28125 13.9609H10.8626",
    stroke: "#5A6068",
    strokeWidth: 0.797337,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1402_4445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3521,
    height: 14.3521,
    fill: "white",
    transform: "translate(0.496094 0.808594)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeal);
export default __webpack_public_path__ + "static/media/meal.db371731356405e4b9fb514a2bdc8f73.svg";
export { ForwardRef as ReactComponent };